import { t } from "i18next";

export const dialogTexts = {
	prompt: {
		title: t("dashboard.reviewPrompt.title"),
		body: t("dashboard.reviewPrompt.body"),
	},
	feedback: {
		title: "dialog.feedback.title",
		body: "dialog.feedback.body",
	},
	deletefeedback: {
		title: "dialog.delete.title",
		body: "dialog.delete.body",
		options: "dialog.delete.options",
	},
	confirmdelete: {
		title: "dialog.delete.confirmdelete.title",
	},
};

export const defaultFeedbackSubtitle = "dialog.feedback.defaultFeedbackBody";

export const feedbackEvents = {
	reviewDialogOpened: "mem_review_dialog_opened",
	reviewDialogClosed: "mem_review_dialog_closed",
	reviewNegativeClicked: "mem_review_negative_clicked",
	reviewPositiveClicked: "mem_review_positive_clicked",
	feedbackDialogOpened: "mem_feedback_dialog_opened",
	feedbackDialogClosed: "mem_feedback_dialog_closed",
	feedbackSent: "mem_feedback_sent",
	deleteAccountDialogOpened: "mem_delete_account_dialog_opened",
	deleteAccountDialogDimissed: "mem_delete_account_dialog_dimissed",
	deleteAccountConfirmShown: "mem_delete_account_confirm_shown",
	deleteFeedbackSent: "mem_delete_feedback_sent",
	accountDeleted: "mem_account_deleted",
};
